import {
  onBeforeUnmount,
  onMounted,
  onUpdated,
  ref,
  watch,
} from '@nuxtjs/composition-api'
import { useBreakpoint } from './useBreakpoint'
import { ReactiveValue } from '~/types/common'

export const useHeaderHeight = (
  _shouldWatchScroll: ReactiveValue<boolean> | boolean
) => {
  const { isMobile } = useBreakpoint()

  const shouldWatchScroll = ref(_shouldWatchScroll)
  const height = ref(0)
  const scrolledHeight = ref(0)

  const getHeight = () => {
    height.value =
      (document.querySelector('#app-header') as HTMLElement)?.offsetHeight ?? 0
    return height.value
  }

  const getScrolledHeight = () => {
    if (isMobile.value) {
      scrolledHeight.value = height.value
      return
    }

    const baseScrolledHeight = 80
    const menuDesktopHeight =
      (document.querySelector('#app-menu-desktop') as HTMLElement)
        ?.offsetHeight ?? 0
    scrolledHeight.value = baseScrolledHeight + menuDesktopHeight
  }

  const init = () => {
    getHeight()
    getScrolledHeight()
  }

  watch(
    shouldWatchScroll,
    (val) => {
      if (!process.client) return
      if (val) {
        window.addEventListener('scroll', init)
      } else {
        window.removeEventListener('scroll', init)
      }
    },
    {
      immediate: true,
    }
  )

  onMounted(() => {
    init()
  })

  onUpdated(() => {
    init()
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', init)
  })

  return {
    height,
    scrolledHeight,
    getHeight,
    getScrolledHeight,
  }
}
